import React, { useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBackIos";
import ResponsiveCourseNavnarForDivices from "../NavBar/ResponsiveNavbarForDivices";
import { useNavigate } from "react-router-dom";

const LiveStramOfYoutube = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/profile");
  };
  return (
    <>
      {isMobile ? (
        <AppBar
          position="sticky"
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleBack}>
              <ArrowBackIcon sx={{ color: "black" }} />
            </IconButton>
            <Typography variant="h6" sx={{ flexGrow: 1, color: "black" }}>
              {/* {pageTitle} */}
              Live Stream
            </Typography>
          </Toolbar>
        </AppBar>
      ) : (
        <ResponsiveCourseNavnarForDivices />
      )}
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} sm={8} md={6}>
          <Card
            style={{
              backgroundColor: "#1e1e1e",
              color: "white",
              // borderRadius: "16px",
              overflow: "hidden",
            }}
          >
            <CardContent style={{ textAlign: "center" }}>
              {/* Embedded YouTube Video using iframe */}
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  aspectRatio: "16/9",
                }}
              >
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/_MLl3ZFLJOA?autoplay=1&rel=0&modestbranding=1&showinfo=0"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              <Typography variant="h6" style={{ marginTop: "16px" }}>
                Enjoy the Video
              </Typography>
              <Typography variant="body2" color="gray">
                A smooth and engaging YouTube experience.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default LiveStramOfYoutube;
